"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var actioncable_1 = __importDefault(require("actioncable"));
var apollo_link_1 = require("apollo-link");
var apollo_utilities_1 = require("apollo-utilities");
var printer_1 = require("graphql/language/printer");
var getChannelId = function () {
    return Math.round(Date.now() + Math.random() * 100000).toString(16);
};
function createSubscriptionLink(endpoint) {
    var cable;
    var currentToken;
    var channelName = 'GraphqlChannel';
    var actionName = 'execute';
    var connectionParams = {};
    // @ts-ignore logger missing in typings
    if (actioncable_1.default.logger) {
        // @ts-ignore logger missing in typings
        actioncable_1.default.logger.enabled = true;
    }
    return new apollo_link_1.ApolloLink(function (operation) {
        var token = operation.getContext().token;
        if (!token) {
            throw new Error("Subscribing to " + operation.operationName + " before authenticated");
        }
        if (!cable || currentToken !== token) {
            var cableUrl = endpoint + "/cable?token=" + token;
            cable = actioncable_1.default.createConsumer(cableUrl);
            currentToken = token;
        }
        return new apollo_link_1.Observable(function (observer) {
            var channelId = getChannelId();
            var subscription = cable.subscriptions.create(Object.assign({}, {
                channel: channelName,
                channelId: channelId,
            }, connectionParams), {
                connected: function () {
                    this.perform(actionName, {
                        query: operation.query ? printer_1.print(operation.query) : null,
                        variables: operation.variables,
                        // @ts-ignore
                        operationId: operation.operationId,
                        operationName: operation.operationName,
                    });
                },
                received: function (payload) {
                    if (payload.result.data) {
                        observer.next(payload.result);
                    }
                    if (!payload.more) {
                        this.unsubscribe();
                        observer.complete();
                    }
                },
                disconnected: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    console.log.apply(console, __spread(['subscription disconnected'], args));
                },
            });
            return subscription;
        });
    });
}
exports.createSubscriptionLink = createSubscriptionLink;
function isSubscriptionOperation(_a) {
    var query = _a.query;
    var operation = apollo_utilities_1.getOperationDefinitionOrDie(query).operation;
    return operation === 'subscription';
}
exports.isSubscriptionOperation = isSubscriptionOperation;
//# sourceMappingURL=subscriptionLink.js.map